import React from 'react';
import { Nav } from './components/Nav';
import { Hero } from './components/Hero';
import { Engagements } from './components/Engagements';
import { Scope } from './components/Scope';
import { Record } from './components/Record';
import { ArticleIndex } from './components/ArticleIndex';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen w-full bg-bone text-ink" data-id="element-0" data-mp="2rk41sqtu8cao">
      <Nav data-id="element-1" data-mp="2rikrdguv4vgt" />
      <main id="top" data-id="element-2" data-mp="2mm2lgdnsqr2w">
        <Hero data-id="element-3" data-mp="2mmlv773am95u" />
        <Engagements data-id="element-4" data-mp="2mn5ash5h0lgp" />
        <Scope data-id="element-5" data-mp="2mnnefyugq1yn" />
        <Record data-id="element-6" data-mp="2mjzn96chprn3" />
        <ArticleIndex data-id="element-7" data-mp="31agoopp4khjz" />
        <Contact data-id="element-8" data-mp="31bs2licab5ot" />
      </main>
      <Footer data-id="element-9" data-mp="31c1gw8nyvoeo" />
    </div>;
}